var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUndoTool = function SvgUndoTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m11.8 10.55-1.3-1.3c-.6-.6-1.5-.2-1.5.6v4.9c0 .5.4.9.9.9h4.9c.8 0 1.2-.9.6-1.5l-1.5-1.5c1.1-1 2.6-1.6 4.1-1.6 3.4 0 6.2 2.7 6.2 6.1 0 3.3-2.7 6-6.1 6-1.5 0-2.9-.5-4-1.5-.2-.2-.4-.1-.6 0l-1.5 1.4c-.2.2-.2.5 0 .6 1.6 1.4 3.7 2.3 6 2.3 5 0 9-4 9-9 0-4.9-4.1-8.9-9-8.9-2.4 0-4.6 1-6.2 2.5z",
    fillRule: "evenodd"
  })));
};

export default SvgUndoTool;